module.exports = __webpack_public_path__ + "static/media/menu.9bb5c612.svg";